/**
 * @file pages/NotFoundPage.js
 * @description The suite's 404. Before this existed, an unknown path under the
 * app rendered NOTHING (the inner router had no catch-all, and the Navbar hides
 * itself for signed-out visitors) — a blank, dead-end document. This page gives
 * that case a real shell and, most importantly, a way out: a prominent Hub link
 * back to butlercore.com/app so no wrong URL ever traps the user.
 *
 * Phone-first and theme-aware (design tokens). Renders inside the app shell, so
 * a signed-in user also keeps the Navbar above it; a signed-out visitor still
 * gets this page + the Hub button and is never stuck.
 */
import React from 'react';

export default function NotFoundPage() {
  return (
    <div
      style={{
        minHeight: '70vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        padding: 'var(--space-8) var(--space-4)',
        maxWidth: 520,
        width: '100%',
        margin: '0 auto',
      }}
    >
      <div style={{ fontSize: '3rem', lineHeight: 1, marginBottom: 'var(--space-4)' }} aria-hidden="true">
        🧭
      </div>
      <h1
        style={{
          fontSize: 'var(--text-heading-lg, 1.6rem)',
          fontWeight: 'var(--weight-bold)',
          margin: '0 0 var(--space-2)',
          color: 'var(--text-primary)',
        }}
      >
        Page not found
      </h1>
      <p
        style={{
          color: 'var(--text-secondary)',
          margin: '0 0 var(--space-6)',
          lineHeight: 1.5,
        }}
      >
        That page moved, or the link was mistyped. Let&apos;s get you back to your apps.
      </p>
      {/* Absolute link to the hub so the escape works no matter how the 404 was
          reached (even before the app has authenticated / hydrated). Matches the
          "← Hub" control the other modules use. */}
      <a
        href="https://butlercore.com/app"
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: 'var(--space-2)',
          background: 'var(--color-primary)',
          color: '#fff',
          textDecoration: 'none',
          fontWeight: 'var(--weight-semibold)',
          padding: 'var(--space-3) var(--space-5)',
          borderRadius: 'var(--radius-md)',
          fontSize: 'var(--text-body, 1rem)',
        }}
      >
        <span aria-hidden="true">←</span> Back to Hub
      </a>
    </div>
  );
}
